import Modal from 'react-bootstrap/Modal';
import './GraphModal.css';
import React from 'react';
import BuzzlistWindow from '../../container/pages/BuzzlistWindow';

const GraphModal = (props) => {

  return (
    <Modal show={props.showModal} onHide={props.closeBuzzlistWindow} dialogClassName="graph-modal" aria-labelledby="custom-modal-styling">
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body scrollable={true} >
        <BuzzlistWindow clickedData={props.clickedData} reportType={props.reportType} mainQuery={props.mainQuery} subQuery={props.subQuery} subQueryType={props.subQueryType} reTweet={props.reTweet} channels={props.channels}
          userRole={props.userRole} closeBuzzlistWindow={props.closeBuzzlistWindow}
        />
      </Modal.Body>
  </Modal>

  )
}

export default GraphModal;